import { Injectable } from '@angular/core';
import { ApiHttpService } from './api-http.service';
import { Observable } from 'rxjs';

@Injectable()
export class GrowthStageService {

  constructor(private apiHttp: ApiHttpService) {}

  public getAll = (): Observable<GrowthStage[]> => {
    return this.apiHttp.get<GrowthStage[]>("growthstages");
  };

  public get = (id: number): Observable<GrowthStage> => {
    return this.apiHttp.get<GrowthStage>(`growthstages/${id}`);
  };
}

export interface GrowthStage {
  id: number;
  name: string;
  order: number;
  isActive: boolean;
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/services/growth-stage.service.ts